<template>
  <div class="fk-head">
    <el-tabs v-model="activeName"  type="border-card">
  <el-tab-pane name="first">
    <span slot="label"><i class="el-icon-s-order"></i><label>待准入</label></span>
     <my-fktable v-if="activeName==='first'"  :rType="1" @openCheck="openCheck"></my-fktable>
  </el-tab-pane>
  <el-tab-pane name="second">
    <span slot="label"><i class="el-icon-s-claim"></i><label>已准入</label></span>
     <my-fktable  v-if="activeName==='second'" :rType="2" @openCheck="openCheck"></my-fktable>
  </el-tab-pane>
 <el-tab-pane name="third">
    <span slot="label"><i class="el-icon-success"></i><label>已处理</label></span>
      <my-fktable   v-if="activeName==='third'"  :rType="3" @openCheck="openCheck"></my-fktable>
  </el-tab-pane>
   <el-tab-pane name="fourth">
    <span slot="label"><i class="el-icon-question"></i><label>异常记录</label></span>
      <my-fktable  v-if="activeName==='fourth'" :rType="4" @openCheck="openCheck"></my-fktable>
  </el-tab-pane>
</el-tabs>
 <listen ref="listenFksysTable"></listen>
  </div>
</template>
<script>
import fktable from "@/components/fksys/fksysTable"; //列表查询（包含待准入，已准入，已处理，异常记录）
import listen from "@/components/fksys/listen"; //监听（监听是否有新的弹出处理）
//import publish_ from "@/components/publish"; //引用模块进来

import {
  getToDayGuardReservationList
} from "@/api/api";

export default {
  components: {
    "my-fktable": fktable,
    "listen":listen
  },
  data() {
    return {
     activeName: "first",
    };
  },
  methods: {
    //刷新加载数据
   openCheck(rid)
   {
      this.$refs.listenFksysTable.cardApp(rid);
   }
  },
  created(){
    if(window.sessionStorage.activeName)
    {
      if(window.sessionStorage.activeName==='1')
      {
       this.activeName="first";
      }
      else if(window.sessionStorage.activeName==='2')
      {
       this.activeName="second";
      }
      else if(window.sessionStorage.activeName==='3')
      {
       this.activeName="third";
      }
      else if(window.sessionStorage.activeName==='4')
      {
       this.activeName="fourth";
      }
    }
     window.localStorage.removeItem('rid');
  }
};
</script>

<style>
 
</style>




// WEBPACK FOOTER //
// src/views/fksys/index.vue